import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cardClasses } from './styles.js';
/**
 * 面（card）primitive。`rounded-md border border-border bg-card` を各 app の inline
 * 宣言から集約する。`as` で landmark（section/header/li 等）を保ったまま装飾でき、
 * `shadow='none'` で影のないリスト枠も表現できる。
 */
export const Card = forwardRef(function Card({ as: Tag = 'div', padding, shadow, border, className, ...rest }, ref) {
    return (_jsx(Tag, { ref: ref, className: cardClasses({ padding, shadow, border, className }), ...rest }));
});
//# sourceMappingURL=Card.js.map